Vue.component('configurator3dDetail',
    {
        data() {
            return {
                iframeWebGL: null,
                data: '',
                colijnData: '',
                configurator3d: null,
                emailSentSuccess: false,
                emailSentMessage: '',
                isEmailDisabled: false
            };
        },
        props: [
            'toggleconfigurator3d',
            'src',
            'customernumber',
            'shopname',
            'windowhasscrollbar'
        ],
        mounted() {

            Vue.nextTick(() => {

                this.iframeWebGL = document.getElementById('iframeWebGL');

                this.iframeWebGL.addEventListener('load', evt => this.loadWebGlHandler());

                Vue.nextTick(() => {

                    if (typeof this.src !== "undefined") {
                        this.iframeWebGL.src = this.src;

                        var receiptbutton = document.getElementById('receiptbutton');

                        var incompatiblebrowser =
                            document.getElementsByClassName('configurator-3d__incompatiblebrowser');

                        if (incompatiblebrowser != null &&
                            incompatiblebrowser.length > 0 &&
                            this.src === "IE") {
                            this.iframeWebGL.style.display = "none";
                            incompatiblebrowser[0].style.display = "block";

                            receiptbutton.style.display = "none";

                        } else {
                            var nocustomerlicense =
                                document.getElementsByClassName('configurator-3d__nocustomerlicense');

                            if (nocustomerlicense != null &&
                                nocustomerlicense.length > 0 &&
                                this.src === "NOLICENSE") {
                                this.iframeWebGL.style.display = "none";
                                nocustomerlicense[0].style.display = "block";

                                receiptbutton.style.display = "none";

                            }
                        }


                    }

                });

            });

        },
        watch: {

        },

        created: function () {
            window.addEventListener('message', evt => this.on3dMessageReceive(evt));
        },
        destroyed: function () {
            window.removeEventListener('message', evt => this.on3dMessageReceive(evt));
        },

        methods: {

            email(e) {
                e.preventDefault();

                if (e.target.elements.NarrowcastingEmail.value !== '') {

                    this.isEmailDisabled = true;

                    fetch('/api/articleconfigurator/email3d', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': document.documentElement.lang,
                            'X-Requested-With': 'XMLHttpRequest'
                        },
                        credentials: 'same-origin',
                        body: JSON.stringify({
                            Email: e.target.elements.NarrowcastingEmail.value,
                            Configurator3d: this.configurator3d,
                            Url: e.target.elements.EmailUrl3d.value,
                            CustomerNumber: this.customernumber,
                            ShopName: this.shopname,
                            IsRoomPlanner: e.target.elements.IsRoomPlanner.value,
                            IsRoomPlanner2D: e.target.elements.IsRoomPlanner2D.value
                        }),
                    }).then(response => response.json()).then((registerResponse) => {

                        this.isEmailDisabled = false;

                        if (!registerResponse.emailSucceeded && registerResponse.errorMessage !== '' && !e.target.elements.NarrowcastingEmail.classList.contains('has-error')) {

                            this.emailSentMessage = registerResponse.errorMessage;

                            validate.showError(e.target.elements.NarrowcastingEmail, registerResponse.errorMessage);

                        } else if (registerResponse.emailSucceeded) {
                            e.target.elements.NarrowcastingEmail.value = '';
                            this.emailSentSuccess = true;
                            setTimeout(() => { this.emailSentSuccess = false; }, 2000);
                        }

                    });

                }
            },

            handleProductCheckbox(product, configItem, i, targetChecked) {

                // if radio button then don't allow uncheck
                if (configItem.radioButton === true && configItem.showConsumer === false) {

                    Vue.nextTick(() => {
                        configItem.showConsumer = true;
                    });
                    return;
                }

                console.log(configItem.articleCode);
                //needed for zembla + novara 2, 5 - zits + longchair links etc.
                if (configItem.optionGroupCode === "3011" && configItem.level === 1 && configItem.visible && configItem.articleCode.endsWith('POC')) {
                    Vue.nextTick(() => {
                        configItem.showConsumer = true;
                    });
                    return;
                }


                let optionBlockStartIndex = i;
                let optionBlockEndIndex = i;
                if (i > 0) {
                    for (let x = i - 1; x >= 0; x -= 1) {

                        let option = product.currentConfigurationList[x];
                        if (option.checkBox === true || option.radioButton === true) {
                            if (configItem.optionGroupCode !== option.optionGroupCode) {
                                break;
                            }
                            optionBlockStartIndex = x;
                        }
                    }
                }

                for (let x = i + 1; x < product.currentConfigurationList.length; x += 1) {

                    let option = product.currentConfigurationList[x];

                    if (option.checkBox === true || option.radioButton === true) {
                        if (configItem.optionGroupCode !== option.optionGroupCode) {
                            break;
                        }
                        optionBlockEndIndex = x;
                    }
                }

                // more than one option in a block
                if (optionBlockStartIndex !== optionBlockEndIndex) {

                    // X level 0
                    //    X level 1
                    //    X level 1
                    // X level 0
                    //    X level 1

                    if (targetChecked === false) {
                        // if uncheck : uncheck and hide all higher level checkboxes below
                        for (let x = i + 1; x <= optionBlockEndIndex; x += 1) {

                            let option = product.currentConfigurationList[x];

                            if (option.level > configItem.level) {
                                option.showConsumer = false;
                                option.visible = false;
                            } else {
                                break;
                            }
                        }
                    } else {

                        // if check level 0 : uncheck all other level 0 checkboxes 

                        for (let x = optionBlockStartIndex; x <= optionBlockEndIndex; x += 1) {

                            let option = product.currentConfigurationList[x];

                            if (x !== i && option.level === 0 && configItem.level === 0) {
                                option.showConsumer = false;
                            }

                            // if check level 1 and radio button : uncheck all other level 1 radio buttons

                            if (x !== i && option.level === 1 && configItem.level === 1 && option.radioButton === true) {
                                option.showConsumer = false;
                            }

                        }

                        // if any level 0  unchecked, then : uncheck and hide all level 1 checkboxes below 
                        for (let x = optionBlockStartIndex; x <= optionBlockEndIndex; x += 1) {

                            let option = product.currentConfigurationList[x];

                            if (x > 0 && option.level > 0) {

                                var higherlevel = {};
                                for (let y = x - 1; y >= optionBlockStartIndex; y -= 1) {

                                    higherlevel = product.currentConfigurationList[y];

                                    if (product.currentConfigurationList[y].level === 0)
                                        break;
                                }

                                if (higherlevel.showConsumer === false) {
                                    option.showConsumer = false;
                                    option.visible = false;
                                }
                            }
                        }

                        // if level is 0, unhide the next higher level below
                        if (configItem.level === 0) {

                            for (let x = i + 1; x <= optionBlockEndIndex; x += 1) {

                                let option = product.currentConfigurationList[x];

                                if (option.level > configItem.level) {

                                    if (option.level === configItem.level + 1) {
                                        option.visible = true;

                                        //needed for zembla + novara 2, 5 - zits + longchair links etc.
                                        if (targetChecked && option.optionGroupCode === "3011" && option.articleCode.endsWith('POC')) {
                                            option.showConsumer = true;
                                        }

                                        // if radio button on level one, check the first one
                                        if (x === i + 1 && option.level === 1 && option.radioButton === true) {
                                            option.showConsumer = true;
                                        }
                                    }

                                } else {
                                    break;
                                }
                            }
                        } else if (configItem.level > 0) {

                            // if level  > 0

                            // X level 0
                            //    X level 1
                            //    X level 1
                            // X level 0
                            //    X level 1

                            // denver level 1 checkboxes, under level 0 radio button : uncheck all other level 1 checkboxes
                            if (product.currentConfigurationList[optionBlockStartIndex].radioButton === true && optionBlockEndIndex > optionBlockStartIndex && product.currentConfigurationList[optionBlockStartIndex + 1].checkBox === true) {

                                if (configItem.level === 1 && configItem.checkBox === true) {

                                    for (let x = optionBlockStartIndex; x <= optionBlockEndIndex; x += 1) {

                                        let option = product.currentConfigurationList[x];

                                        if (x !== i && option.level > 0) {
                                            option.showConsumer = false;

                                            if (x !== i && option.level > configItem.level) {
                                                option.visible = false;
                                            }
                                        }
                                    }
                                }

                                // show current and higher levels below
                                for (let x = i + 1; x <= optionBlockEndIndex; x += 1) {

                                    let option = product.currentConfigurationList[x];
                                    if (option.level > configItem.level) {

                                        option.visible = true;

                                    } else {
                                        break;
                                    }
                                }

                            } else {

                                // show current and higher levels below
                                for (let x = i; x <= optionBlockEndIndex; x += 1) {

                                    let option = product.currentConfigurationList[x];

                                    if (option.level >= configItem.level) {

                                        option.visible = true;

                                    } else {
                                        break;
                                    }
                                }
                            }

                            // check and show all lower levels above

                            //if (i > 0) {
                            //    var higherLevel = configItem.level;
                            //    for (let x = i - 1; x >= optionBlockStartIndex; x -= 1) {
                            //        let option = product.currentConfigurationList[x];
                            //        if (option.level < higherLevel) {
                            //            higherLevel = option.level;
                            //            option.showConsumer = true;
                            //            option.visible = true;
                            //        }
                            //    }
                            //}
                        }
                    }
                }

                // when printing : don't show caption if no articles ar checked
                // because unchecked items are hidden on the printer
                let anyCheckBoxFound = false;
                for (let x = optionBlockStartIndex; x <= optionBlockEndIndex; x += 1) {

                    let option = product.currentConfigurationList[x];

                    if (option.showConsumer === true) {
                        anyCheckBoxFound = true;
                    } else {
                        option.hideGroupCaption = true;
                    }
                }
                if (anyCheckBoxFound) {
                    for (let x = optionBlockStartIndex; x <= optionBlockEndIndex; x += 1) {

                        let option = product.currentConfigurationList[x];

                        option.hideGroupCaption = false;
                    }
                }


                // for napels
                // force headrest if electrical system is checked
                for (let y = 0; y < product.currentConfigurationList.length; y += 1) {

                    let option1 = product.currentConfigurationList[y];

                    // if any article, where forceHeadrest is true, is checked
                    if (option1.showConsumer === true && option1.forceHeadrest === true) {
                        
                        for (let x = 0; x < product.currentConfigurationList.length; x += 1) {

                            let option2 = product.currentConfigurationList[x];

                            // then also check the article with headrestArticleCode (and don't allow uncheck)

                            if (option2.showConsumer === false && option2.articleCode === product.headrestArticleCode) {

                                Vue.nextTick(() => {
                                    option2.showConsumer = true;
                                    this.handleProductCheckbox(product, option2, x, true);
                                });
                            }
                        }
                        break;
                    }
                }

            },

            handleOptionSynchronisation(configurator3d, product, configItem, i, targetChecked) {
                
                if (configurator3d.productList.length > 1) {

                    // for napels
                    // force headrest if electrical system is checked

                    let headrestMustBeChecked = false;

                    configurator3d.productList.forEach((product2) => {

                        if(product2.furnitureId === product.furnitureId)
                        {

                            for (let x = 0; x < product2.currentConfigurationList.length; x += 1) {

                                let option = product2.currentConfigurationList[x];

                                // if any article, where headrest is mandatory, is checked
                                if (option.showConsumer === true && option.forceHeadrest) {
                                    headrestMustBeChecked = true;
                                }
                            }
                        }
                    });


                    // napels
                    // headrest in all corner sofa modules must be the same

                    let anyHeadrestIsChecked = false;

                    configurator3d.productList.forEach((product2) => {

                        if (product2.headrestArticleCode && product2.furnitureId === product.furnitureId) {

                            for (let x = 0; x < product2.currentConfigurationList.length; x += 1) {

                                let option2 = product2.currentConfigurationList[x];

                                // if any headrest article is checked

                                if (option2.showConsumer === true &&
                                    option2.articleCode === product2.headrestArticleCode) {
                                    anyHeadrestIsChecked = true;
                                }
                            }
                        }
                    });

                    // if uncheck a headrest and headrestMustBeChecked = false then uncheck all other headrests
                    if (product.headrestArticleCode &&
                        targetChecked === false &&
                        headrestMustBeChecked === false &&
                        configItem.articleCode === product.headrestArticleCode) {

                        configurator3d.productList.forEach((product2) => {

                            if (product !== product2 && product2.furnitureId === product.furnitureId && product2.headrestArticleCode) {

                                for (let x = 0; x < product2.currentConfigurationList.length; x += 1) {

                                    let option2 = product2.currentConfigurationList[x];

                                    // uncheck the checked article with headrest articlecode

                                    if (option2.showConsumer === true && option2.articleCode === product2.headrestArticleCode) {

                                        Vue.nextTick(() => {
                                            option2.showConsumer = false;
                                            this.handleProductCheckbox(product2, option2, x, false);
                                        });
                                    }
                                }
                            }
                        });

                    }
                    else if (anyHeadrestIsChecked === true || headrestMustBeChecked === true) {

                        // check all headrest if any electrical system checked in any module or any headrest checked in any module

                        configurator3d.productList.forEach((product2) => {

                            if (product2.furnitureId === product.furnitureId && product2.headrestArticleCode) {

                                for (let x = 0; x < product2.currentConfigurationList.length; x += 1) {

                                    let option2 = product2.currentConfigurationList[x];

                                    // check the unchecked article with headrest articlecode

                                    if (option2.showConsumer === false && option2.articleCode === product2.headrestArticleCode) {

                                        Vue.nextTick(() => {
                                            option2.showConsumer = true;
                                            this.handleProductCheckbox(product2, option2, x, true);
                                        });
                                    }
                                }
                            }
                        });
                    }

                    if ((product.originalCollection === "Denver") &&
                        (configItem.level === 0) &&
                        (configItem.optionGroupCode === "3008")) {
                        configurator3d.productList.forEach((product2) => {

                            if (product2 !== product && product2.furnitureId === product.furnitureId) {

                                let articleFound = false;

                                for (let x = 0; x < product2.currentConfigurationList.length; x += 1) {

                                    let configItem2 = product2.currentConfigurationList[x];

                                    if (configItem2.optionGroupCode === configItem.optionGroupCode &&
                                        configItem2.level === 0) {

                                        if (configItem.checkBox === true) {

                                            // checkbox off, set the other radio button
                                            if (!targetChecked &&
                                                configItem2.radioButton === true &&
                                                configItem2.articleCode.substr(configItem2.articleCode.length - 3) !==
                                                configItem.articleCode.substr(configItem.articleCode.length - 3)) {
                                                configItem2.showConsumer = true;
                                                articleFound = true;
                                                this.handleProductCheckbox(product2, configItem2, x, true);
                                            }

                                            // checkbox on, set the same radio button
                                            if (targetChecked &&
                                                configItem2.radioButton === true &&
                                                configItem2.articleCode.substr(configItem2.articleCode.length - 3) ===
                                                configItem.articleCode.substr(configItem.articleCode.length - 3)) {
                                                configItem2.showConsumer = true;
                                                articleFound = true;
                                                this.handleProductCheckbox(product2, configItem2, x, true);
                                            }

                                            // checbox on/off, set the same checkbox on/off
                                            if (configItem2.checkBox === true && configItem2.articleCode.substr(configItem2.articleCode.length - 3) ===
                                                configItem.articleCode.substr(configItem.articleCode.length - 3)) {
                                                configItem2.showConsumer = targetChecked;
                                                articleFound = true;
                                                this.handleProductCheckbox(product2, configItem2, x, targetChecked);
                                            }

                                        } else if (configItem.radioButton === true) {

                                            // radio button, set the same radio button or checkbox
                                            if (configItem2.articleCode.substr(configItem2.articleCode.length - 3) ===
                                                configItem.articleCode.substr(configItem.articleCode.length - 3)) {
                                                configItem2.showConsumer = targetChecked;
                                                articleFound = true;
                                                this.handleProductCheckbox(product2, configItem2, x, targetChecked);
                                            }

                                            // radio button, uncheck other checkbox
                                            if (configItem2.checkBox === true && configItem2.articleCode.substr(configItem2.articleCode.length - 3) !==
                                                configItem.articleCode.substr(configItem.articleCode.length - 3)) {
                                                configItem2.showConsumer = false;
                                                articleFound = true;
                                                this.handleProductCheckbox(product2, configItem2, x, false);
                                            }

                                        }
                                    }
                                }
                            }
                        });
                    }
                    else if ((configItem.level === 0) && (
                            (configItem.optionGroupCode === "3011") || // OPTION FILLING
                            (configItem.optionGroupCode === "2200") || // ARM-REST
                            (configItem.optionGroupCode === "6000") || // CUSHION FILLINGS
                            (configItem.optionGroupCode === "6001") // SEAT DEPTH
                        )) {

                        configurator3d.productList.forEach((product2) => {

                            if (product2 !== product && product2.furnitureId === product.furnitureId) {

                                let articleFound = false;

                                // first check if the same article exists in another product
                                for (let x = 0; x < product2.currentConfigurationList.length; x += 1) {

                                    let configItem2 = product2.currentConfigurationList[x];

                                    if (configItem2.optionGroupCode === configItem.optionGroupCode &&
                                        configItem2.articleCode === configItem.articleCode &&
                                        (configItem.checkBox === true || configItem.radioButton === true)) {

                                        configItem2.showConsumer = targetChecked;
                                        articleFound = true;

                                        this.handleProductCheckbox(product2, configItem2, x, targetChecked);
                                    }
                                }

                                // if not found then check last 3 letters
                                if (articleFound === false) {
                                    for (let x = 0; x < product2.currentConfigurationList.length; x += 1) {

                                        let configItem2 = product2.currentConfigurationList[x];

                                        if (configItem2.optionGroupCode === configItem.optionGroupCode &&
                                            configItem2.articleCode.substr(configItem2.articleCode.length - 3) === configItem.articleCode.substr(configItem.articleCode.length - 3) &&
                                            configItem2.level === 0 &&
                                            (configItem.checkBox === true || configItem.radioButton === true)) {

                                            configItem2.showConsumer = targetChecked;
                                            articleFound = true;

                                            this.handleProductCheckbox(product2, configItem2, x, targetChecked);
                                        }
                                    }
                                }

                                // if not found then just update another article for the same optiongroup
                                if (articleFound === false) {
                                    for (let x = 0; x < product2.currentConfigurationList.length; x += 1) {

                                        let configItem2 = product2.currentConfigurationList[x];

                                        if (configItem2.optionGroupCode === configItem.optionGroupCode &&
                                            configItem2.level === 0 &&
                                            (configItem.checkBox === true || configItem.radioButton === true)) {

                                            configItem2.showConsumer = targetChecked;

                                            this.handleProductCheckbox(product2, configItem2, x, targetChecked);
                                        }
                                    }
                                }
                            }
                        });
                    }

                }

            },

            checkboxClick(configurator3d, product, configItem, i, targetChecked) {

                this.handleProductCheckbox(product, configItem, i, targetChecked);

                this.handleOptionSynchronisation(configurator3d, product, configItem, i, targetChecked);

            },

        levelPrefix(level) {
            let levelpx = -16;
            if (level > 0) {
                for (var i = 0; i < level; i += 1) {
                    levelpx += 21;
                }
            }

            var x = { marginLeft : levelpx + "px"};
            return x;
       
        },

        close3dmodal(index) {

            if (typeof this.toggleconfigurator3d !== "undefined") {
                this.toggleconfigurator3d(false);
            }

            setTimeout(() => {

                if (index === 0) {
                    app.$refs.shoppinglistheaderbutton.click();
                } else {

                    app.$refs.shoppinglistheaderbutton1.click();
                }
            }, 400);
        },

        toPriceString(value,hostLanguage) {

            var v = '';

            //var w = value.toLocaleString(hostLanguage, { style: 'currency', minimumFractionDigits: 0, maximumFractionDigits: 2, currency: 'EUR' });

            switch (hostLanguage) {
            case 'en-NL':
            case 'nl-BE':
            case 'fr-BE':
            case 'de-BE':
            case 'de-AT':
                    v = new Intl.NumberFormat('nl', { style: 'currency', minimumFractionDigits: 0, maximumFractionDigits: 2, currency: 'EUR' }).format(value);
                    if (Number(value) === value && value % 1 === 0) v += ',-';
                    break;
            case 'de':
            case 'fr-LU':
            case 'de-LU':
                v = new Intl.NumberFormat(hostLanguage, { style: 'currency', minimumFractionDigits: 0, maximumFractionDigits: 2, currency: 'EUR' }).format(value);
                if (Number(value) === value && value % 1 === 0) v = v.replace(/\xA0/g, ',-' + String.fromCharCode(0xA0));
                break;
            case 'de-CH':
            case 'fr-CH':
                v = new Intl.NumberFormat(hostLanguage, { style: 'currency', minimumFractionDigits: 0, maximumFractionDigits: 2, currency: 'CHF' }).format(value);
                if (Number(value) === value && value % 1 === 0) v = v.replace(/\xA0/g, '.-' + String.fromCharCode(0xA0));
                break;
            case 'en-IE':
                    v = new Intl.NumberFormat(hostLanguage, { style: 'currency', minimumFractionDigits: 0, maximumFractionDigits: 2, currency: 'EUR' }).format(value);
                    if (Number(value) === value && value % 1 === 0) v += '.-';
                break;
            case 'en-GB':
                v = new Intl.NumberFormat(hostLanguage, { style: 'currency', minimumFractionDigits: 0, maximumFractionDigits: 2, currency: 'GBP' }).format(value);
                if (Number(value) === value && value % 1 === 0) v += '.-';
                break;
            default:
                v = new Intl.NumberFormat(hostLanguage, { style: 'currency', minimumFractionDigits: 0, maximumFractionDigits: 2, currency: 'EUR' }).format(value);
            }

            return v;
        },

        surcharge(configItem, hostLanguage) {

            return this.toPriceString(configItem.surcharge, hostLanguage);
        },

        productPrice(configurator3d, product, hostLanguage) {

            var optionTotal = 0;

            product.currentConfigurationList.forEach((configItem) => {
                if ((configItem.checkBox === true || configItem.radioButton === true) && configItem.showConsumer) {
                    optionTotal += configItem.surcharge;
                }
            });

            var priceText = "";

            if (product.consumerTotalPrice > 0 &&
                product.actionPrice > 0 &&
                product.consumerTotalPrice !== product.actionPrice) {
                priceText = "<del>" +
                    this.toPriceString(product.consumerTotalPrice + optionTotal, hostLanguage) +
                    "</del> " +
                    this.toPriceString(product.actionPrice + optionTotal, hostLanguage);
            } else {
                priceText = this.toPriceString(product.consumerTotalPrice + optionTotal, hostLanguage);
            }

            if (product.ecoTax > 0) {
                priceText += configurator3d.ecotaxText.replace("#",this.toPriceString(product.ecoTax, hostLanguage));
            }

            return priceText;
        },

        totalPrice(configurator3d, hostLanguage) {

            var optionTotal = 0;

            configurator3d.productList.forEach((product) => {
                product.currentConfigurationList.forEach((configItem) => {
                    if ((configItem.checkBox === true || configItem.radioButton === true) && configItem.showConsumer) {
                        optionTotal += configItem.surcharge;
                    }
                });
            });

            var priceText = "";

                if (configurator3d.consumerTotalPrice > 0 &&
                    configurator3d.actionPrice > 0 &&
                    configurator3d.consumerTotalPrice !== configurator3d.actionPrice) {
                priceText = "<del>" +
                    this.toPriceString(configurator3d.consumerTotalPrice + optionTotal, hostLanguage) +
                    "</del> " +
                    this.toPriceString(configurator3d.actionPrice + optionTotal, hostLanguage);
            } else {
                    priceText = this.toPriceString(configurator3d.consumerTotalPrice + optionTotal, hostLanguage);
            }
            
                if (configurator3d.ecoTax > 0) {
                    priceText += configurator3d.ecotaxText.replace('#', this.toPriceString(configurator3d.ecoTax, hostLanguage));
            }

            return priceText;
        },

        addOrUpdateCart(configurator3d, clear, projectnumber3d, redirectUrl = null, index = 0) {

            app.justAddedToCart = true;

            var listModel = [];

            configurator3d.productList.forEach((product) => {

                var optionTotal = 0;

                if (product.code.length > 3) {

                    product.currentConfigurationList.forEach((configItem) => {
                        if ((configItem.checkBox === true || configItem.radioButton === true) && configItem.showConsumer) {
                            optionTotal += configItem.surcharge;
                        }
                    });

                    var code = /*'p-' +*/ product.code;
                    var displayname = product.displayName;
                    var color = null;
                    var quantity = 1;
                    var lowestPrice = product.actionPrice + optionTotal;
                    var lowestOldPrice = product.consumerTotalPrice + optionTotal;
                    var ecoTax = product.ecoTax;
                    var assemblyCost = '';
                    var actionTotalAmount = 0;
                    var actionFreeAmount = 0;
                    var configuration = product.currentConfigurationList;

                    listModel.push({
                        Code: code,
                        DisplayName: displayname,
                        Color: color,
                        Quantity: quantity,
                        Price: lowestPrice,
                        OldPrice: lowestOldPrice,
                        EcoTax: ecoTax,
                        AssemblyCost: assemblyCost,
                        ActionTotalAmount: actionTotalAmount,
                        ActionFreeAmount: actionFreeAmount,
                        Configuration: configuration,
                        ProjectNumber3d: projectnumber3d,
                        Index: index
                    });

                } else {
                    product.currentConfigurationList.forEach((configItem) => {

                        var code = /*'p-' +*/ configItem.code;
                        var displayname = configItem.displayName;
                        var color = null;
                        var quantity = 1;
                        var lowestPrice = configItem.surcharge;
                        var lowestOldPrice = configItem.surcharge;
                        var ecoTax = configItem.ecoTax;
                        var assemblyCost = '';
                        var actionTotalAmount = 0;
                        var actionFreeAmount = 0;
                        var configuration = null;

                        listModel.push({
                            Code: code,
                            DisplayName: displayname,
                            Color: color,
                            Quantity: quantity,
                            Price: lowestPrice,
                            OldPrice: lowestOldPrice,
                            EcoTax: ecoTax,
                            AssemblyCost: assemblyCost,
                            ActionTotalAmount: actionTotalAmount,
                            ActionFreeAmount: actionFreeAmount,
                            Configuration: configuration,
                            ProjectNumber3d: projectnumber3d,
                            Index: index
                        });

                    });
                }

            });

            fetch(`/api/cart/addorupdatelist?clear=${clear}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': document.documentElement.lang,
                    'X-Requested-With': 'XMLHttpRequest'
                },
                credentials: 'same-origin',
                body: JSON.stringify(listModel),
            }).then(response => response.json()).then((cartData) => {
                app.assignCartData(cartData, index);

                console.log(index);

                this.close3dmodal(index);

                if (redirectUrl !== null) {
                    window.location.href = redirectUrl;
                }
            });

        },

        addOrUpdateCartAppointment(configurator3d, clear, projectnumber3d, redirectUrl, index = 0) {

            app.justAddedToCart = true;


            this.addOrUpdateCart(configurator3d, clear, projectnumber3d, redirectUrl, index);

            //!!!!!!!!!!!!!!!!!!!!!!

            //if (redirectUrl !== null) {
            //    window.location.href = redirectUrl;
            //}

        },

        on3dMessageReceive(event) {

            console.log ("!!!!!!!!!!!!!!!")

            var message = null;

            try {
                message = JSON.parse(event.data);
            } catch (exception) {
                // empty
            }

            if (message !== null && message.data !== null && typeof message.data !== "undefined") {
                
                console.log(JSON.stringify(message.data, (k, v) => (/*k === 'Id' || k === 'ConnectedParts' ||*/ k === 'Rotation' || k === 'Position' || k === 'SupplierArticleNr') ? undefined : v, 2));

                var colijn3ddebug = document.getElementById('colijn3ddebug');
                if (colijn3ddebug != null) {
                    colijn3ddebug.innerHTML = JSON.stringify(message.data, (k, v) => (/*k === 'Id' || k === 'ConnectedParts' ||*/ k === 'Rotation' || k === 'Position' || k === 'SupplierArticleNr') ? undefined : v, 2);
                }

                var c = JSON.stringify(message.data, (k, v) => (/*k === 'Id' || k === 'ConnectedParts' ||*/ k === 'Rotation' || k === 'Position' || k === 'SupplierArticleNr') ? undefined : v);

                if (c !== this.colijnData) {

                    this.colijnData = c;

                    switch (message.method) {
                    case 'updateShoppingCartSelections':

                        fetch('/api/articleconfigurator/handler3d',
                                {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json",
                                        "Accept-Language": document.documentElement.lang,
                                        "X-Requested-With": "XMLHttpRequest"
                                    },
                                    body: this.colijnData,
                                    credentials: 'same-origin',
                                })
                            .then(response => {

                                if (response.ok || response.status === 400) {
                                    return response.json();
                                }
                                throw Error(response.statusText)
                            })
                            .then((response) => {

                                if (typeof response.message !== 'undefined') {

                                    this.data = response.message;

                                } else {

                                    //this.data = Date.now() + "<br>" + response.data;
                                    this.configurator3d = response;

                                    Vue.nextTick(() => {
                                        Vue.nextTick(() => {
                                            fTooltip();
                                        });
                                    });

                                    var receiptbutton = document.getElementById('receiptbutton');
                                    if (receiptbutton != null) {
                                        receiptbutton.style.visibility = "visible";
                                        receiptbutton.style.display = "inline-block";
                                    }

                                }
                            }).catch(error => {

                                this.data = error;

                            });

                        break;
                    case 'returnScreenshot':

                        // returns data like : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABNUAAAKKCAYAAAAa3m0KAAAgAElEQVR4Xu

                        console.log('returnScreenshot');

                        console.log(this.colijnData);
                        break;
                    default:

                    }
                }
            }
        },

        create3dScreenshot() {

            this.iframeWebGL.contentWindow.postMessage(JSON.stringify({
                method: 'returnScreenshot'
            }), '*');

        },

        loadWebGlHandler() {

            //post a message to the iframe to enable the use of a custom selection container
            //don't forget the '*' in the call, and to stringify the object you are sending.
            //the object should always be in the format: {method : methodName, data : dataForMethod}
            this.iframeWebGL.contentWindow.postMessage(JSON.stringify({
                    method: 'enableCustomSelections',
                    data: true
                }),
                '*');

            setTimeout(function () {
            this.iframeWebGL.contentWindow.postMessage(JSON.stringify({
                method: 'initCommunication',
                    data: true
                }),
                '*');
            }, 2000);

            setTimeout(function() {
                    //update the HTML of the selection container using this message
                    this.iframeWebGL.contentWindow.postMessage(JSON.stringify({
                            method: 'setSelectionsHTML',
                            data: '<p>test</p>'
                        }),
                        '*');
                },
                40000);
        }

    }
});
